import * as Yup from 'yup';

export function OptionalLookup(){
    return Yup.number().nullable().default(null).transform(( function(value, originalValue) {if (value === null || value === undefined || Number.isNaN(value)) { return null; } return parseInt(originalValue); }));
}
export function RequiredLookup(requiredMesage){
    return Yup.number().nullable().default(null).required(requiredMesage).transform(( function(value, originalValue) { if (value === null || value === undefined || Number.isNaN(value)) { return null; } return parseInt(originalValue); }));
}
export function OptionalNumber(){
    return Yup.number().nullable().default(null).transform(( function(value, originalValue) { if (!value) { return null; } return parseFloat(originalValue); }));
}
export function RequiredNumber(requiredMesage){
    return Yup.number().nullable().default(null).required(requiredMesage).transform(( function(value, originalValue) { if (!value) { return null; } return parseFloat(originalValue); }));
}
export function OptionalString(){
    return Yup.string().nullable().default(null).transform(( function(value, originalValue) { if (!value) { return null; } return originalValue; }));
}
export function RequiredString(requiredMesage){
    return Yup.string().nullable().default(null).required(requiredMesage).transform(( function(value, originalValue) { if (!value) { return null; } return originalValue; }));
}
export function OptionalDateTime(){
    return Yup.date().nullable().transform(v => (v instanceof Date && !isNaN(v) ? v : null));
}
export function RequiredDateTime(requiredMesage){
    return Yup.date().nullable().required(requiredMesage).transform(v => (v instanceof Date && !isNaN(v) ? v : null));
}
export function OptionalDate(){
    return Yup.date().nullable().transform(v => (v instanceof Date && !isNaN(v) ? v : null));
}
export function RequiredDate(requiredMesage){
    return Yup.date().nullable().required(requiredMesage).transform(v => (v instanceof Date && !isNaN(v) ? v : null));
}

export function OptionalCheckbox(){
    return Yup.bool().default(false).transform(( function(value, originalValue) { if (!value) { return false; } return value; }));
}
export function OptionalBoolean(){
    return Yup.bool().default(null).nullable().transform(( function(value, originalValue) { if (value === null || value === undefined || value === "") { return null; } return !!value; }));
}

export function RequiredBoolean(requiredMesage){
    return Yup.bool().required(requiredMesage).default(null).nullable().transform(( function(value, originalValue) { if (value === null || value === undefined || value === "") { return null; } return !!value; }));
}

export function RequiredTypeAheadMultiple(requiredMesage){
    return Yup.array().default([]).min(1,requiredMesage).transform(( function(value, originalValue) { if (!value) { return []; } return value; }));
}

export function OptionalTypeAheadMultiple(requiredMesage){
    return Yup.array().default([]);
}

export function RequiredSignature(requiredMesage){
    return Yup.string().required(requiredMesage).nullable().matches(/^data:image\/(?:gif|png|jpeg|bmp|webp|svg\+xml)(?:;charset=utf-8)?;base64,(?:[A-Za-z0-9]|[+/])+={0,2}/,"Signature must be png");

}

export function RequiredFile(requiredMesage){
    return Yup.string().required(requiredMesage).nullable().matches(/.*\.pdf$/,"file must be PDF");

}

export function OptionalFile(){
    return Yup.string().default('');

}


